// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Edit-Hardware-Asset_tab__ISh7H {
  &[data-active] {
    background-color: var(--mantine-color-blue-6);
    color: var(--mantine-color-white);
  }
}

.Edit-Hardware-Asset_root__BS2ID {
  /* height: 100%; */
  flex: 1 1;
  
}

.Edit-Hardware-Asset_list__JgerT {
  /* height: 100%; */
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/Admin-Dashboard/Edit-Hardware-Asset.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,6CAA6C;IAC7C,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAO;;AAET;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd","sourcesContent":[".tab {\n  &[data-active] {\n    background-color: var(--mantine-color-blue-6);\n    color: var(--mantine-color-white);\n  }\n}\n\n.root {\n  /* height: 100%; */\n  flex: 1;\n  \n}\n\n.list {\n  /* height: 100%; */\n  height: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab": `Edit-Hardware-Asset_tab__ISh7H`,
	"root": `Edit-Hardware-Asset_root__BS2ID`,
	"list": `Edit-Hardware-Asset_list__JgerT`
};
export default ___CSS_LOADER_EXPORT___;
